import {createFetchClientWithAuth} from '../util/request/middleware'
import {camelCase as camelCaseObject} from 'change-case-object'

const client = createFetchClientWithAuth('v1/')


/**
 * Loads threads
 * @url http://developmentmybudgetapi.azurewebsites.net/swagger/ui/index#!/Thread/Thread_Threads
 * @param count
 * @param sinceThreadId
 * @param status
 * @returns {Promise.<*>|Promise<TResult>}
 */
export function loadThreads(count=20, sinceThreadId, status='inbox'){
	return client.get('threads', {
		query: {
			count: count,
			sincethreadid: sinceThreadId,
			archived: status == 'archived'
		}
	})
}

/**
 * Loads the current unread message count
 * @url http://developmentmybudgetapi.azurewebsites.net/swagger/ui/index#!/Thread/Thread_GetUnreadMessageCount
 * @returns {Promise.<*>|Promise<TResult>}
 */
export async function loadUnreadCount(){
	return (await client.get('threads/unreadMessageCount')).UnreadMessages
}

/**
 * Loads thread info from the server (will be used for push notifications)
 * @return {Promise.reject}
 */
export function loadThreadInfo(/*id*/){
	return new Promise.reject(new Error('Not Yet Implemented'))
}

/**
 * Load messages for a thread
 * @param threadId
 * @return {*}
 */
export async function loadMessages(threadId){
	const response = await client.get(`thread/${threadId}/messages`)

	return response.map(m => {
		if(m.Content !== null){
			m.Content = m.Content.replace(/\\r\\n/g, "\n")
		}
		return m
	})

}

/**
 * Mark a thread as archived
 * @param threadId
 * @param isArchived
 * @returns {number}
 */
export async function archiveThread(threadId, isArchived=true){
	const response = await client.post(`thread/${threadId}/archive`, {
		body: {
			archive: isArchived
		}
	})

	return response.ClientNotificationId
}

/**
 * Replies to a thread
 * @param threadId
 * @param content
 * @param attachments
 * @returns {number}
 */
export async function reply(threadId, content, attachments=[]){
	const response = await client.post(`thread/${threadId}/message`, {
		body: {
			MessageContent: content,
			Attachments: attachments.map((attachment) => attachment.id)
		}
	})

	return response.ClientNotificationId
}

/**
 *
 * @param subject
 * @param categoryCode
 * @param content
 * @param attachments
 * @return {number}
 */
export async function compose(subject, categoryCode, content, attachments=[]){
	const response = await client.post('thread', {
		body: {
			Topic: subject,
			CategoryCode: categoryCode,
			MessageContent: content,
			Attachments: attachments.map((attachment) => attachment.id)
		}
	})

	return response.ClientNotificationId
}

/**
 * Marks a thread as read
 * @param threadId
 * @param isRead
 * @return {number}
 */
export async function markThreadAsRead(threadId, isRead=true){
	const response = await client.post(`thread/${threadId}/read`, {
		body: {
			markAsRead: isRead
		}
	})

	return response.ClientNotificationId
}

/**
 * Fetches the list of categories
 * @return {number}
 */
export async function getCategories(){
	return camelCaseObject(await client.get(`thread/categories`))
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/lib/api/messaging.js